/**
 * Definiert das Modell für die Hotspot-Aufgabe
 * @class service_v3sHotspotElement
 * @memberOf v3sWbtPlayerApp:exercise:hotspot
 */
angular.module('v3sWbtPlayerApp').factory('v3sHotspotElement', ['v3sMapareaElement', function (v3sMapareaElement) {
    /**
     * Konstruktor, setzt die Basiskoordinaten.
     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sHotspotElement
     * @param {number} top - Abstand nach oben in Pixeln
     * @param {number} left - Abstand nach links in Pixeln
     */
    var v3sHotspotElement = function (top, left) {
        this.userAnswer = '';
        this.mapareas = [];
        this.top = top;
        this.left = left;
    };

    // Erstelle ein neues Objekt
    v3sHotspotElement.prototype = new Object();
    
    /**
     * Füge Klickbereich hinzu

     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sHotspotElement
     * @param {string} id
     * @param {boolean} isCorrect
     * @param {number} width Breite des Klickbereichs
     * @param {number} height Höhe des Klickbereichs
     * @param {string} left
     * @param {number} top
     *
     * @return {Object} den erzeugten Klickbereich
     */
    v3sHotspotElement.prototype.addMaparea = function (id, isCorrect, width, height, left, top) {
        var maparea = new v3sMapareaElement(id, isCorrect, width, height, left - this.left, top - this.top);
        this.mapareas.push(maparea);

        return maparea;
    };

    /**
     * Prüfe, ob diese Koordinate korrekt ist. Korrekt ist eine Koordinate, die in einem der
     * definierten Klickbereiche liegt.

     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sHotspotElement
     * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
     * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
     *
     * @return {Object|boolean} die getroffene Fläche, sonst false
     */
    v3sHotspotElement.prototype.isCorrect = function (x, y) {
        for (var i = 0; i < this.mapareas.length; i++) {
            var maparea = this.mapareas[i];
            if (maparea.isCorrect(x, y)) {
                return maparea;
            }
        }

        return false;
    };


    /**
     * Setzt die Nutzerantwort in Form von Koordinaten. Ein angeklickter Bereich wird ggf. auf
     * korrekt gesetzt.

     * @memberOf v3sWbtPlayerApp:exercise:hotspot.service_v3sHotspotElement
     * @param {number} x x-Koordinate relativ zur Hotspot-Aufgabe
     * @param {number} y y-Koordinate relativ zur Hotspot-Aufgabe
     * @param {object} clickElement Das angular.element, welches den Klick anzeigt
     *
     * @return {Object|boolean} die getroffene Fläche, sonst false
     */
    v3sHotspotElement.prototype.setUserAnswer = function (x, y, clickElement) {
        var maparea = this.isCorrect(x, y);

        for (var i = 0; i < this.mapareas.length; i++) {
            if (this.mapareas[i] !== maparea) {
                this.mapareas[i].setUserAnswer();
            }
        }

        if (maparea) {
            maparea.setUserAnswer(x, y, clickElement);
        }

        return maparea;
    };

    return v3sHotspotElement;
}]);